import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Button } from '../../../design-system';
import { ErrorWarningLineIcon } from '../../../design-system/Icons';
import CircularIcon from '../../../design-system/CircularIcon/CircularIcon';

const RestrictedAccessBanner = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { organizationId } = useParams();

    const handleGoBack = () => {
        const backlinkHref = location.state?.from ?? `/settings/organization/${organizationId}`;
        navigate(backlinkHref);
    };

    return (
        <div className="bg-white rounded-2 md:p-8">
            <div className="py-[80px] mx-auto px-4 rounded-2">
                <div className="flex justify-center mb-4">
                    <CircularIcon icon={ErrorWarningLineIcon} />
                </div>
                <div className="max-w-[456px] mx-auto text-center flex flex-col items-center">
                    <p className="uppercase font-body text-body-regular-s text-neutral-300 mb-1">
                        Restricted
                    </p>
                    <p className="font-heading-bold text-heading-bold-m text-black mb-2">
                        Oops! It seems like you don’t have access to this organization
                    </p>
                    <p className="max-w-[346px] mx-auto font-body text-body-regular-m text-black mb-6">
                        Contact your organization owner to add your account to this child
                        organization.
                    </p>
                    <Button type="secondary" size="md" text="Go Back" onClick={handleGoBack} />
                </div>
            </div>
        </div>
    );
};

export default RestrictedAccessBanner;
